import { Row, Col, Card } from "antd";
import classes from "./Dashboard.module.css";
import { Link } from "react-router-dom";
import { PlusCircleOutlined } from "@ant-design/icons";
const DataCards = (props) => {
  // // console.log(props.employeeData.analysis);

  // // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  return (
    <Row>
      <Col lg={8} md={11} xs={24} className={classes["Col"]}>
        <Card
          style={{
            backgroundColor: "#daebf336", // Light sky blue with opacity
          }}
          bordered={true}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/payroll/transactions/daily-attendance"
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Attendance
                </span>
              </Link>
            </Col>
          </Row>
          
            {" "}
            {/* Add gutter for spacing between rows */}
            <Row style={{ width: "100%" }}>
              {" "}
              {/* Ensure full width */}
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Total Employees
                </span>
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{ textAlign: "right" }}
                >
                  {props.data.TotalEmployeesValue !== null
                    ? props.data.TotalEmployeesValue.count
                    : null}
                </div>
              </Col>
            </Row>
          <Row>
            {" "}
            {/* Add gutter for spacing between rows */}
            <Row style={{ width: "100%" }}>
              {" "}
              {/* Ensure full width */}
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Total On Leave
                </span>
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{ textAlign: "right" }}
                >
                  {props.data.TotalOnleaveValue !== null
                    ? props.data.TotalOnleaveValue.total_leaves
                    : null}
                </div>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col
                md={24}
                xs={24} // Ensures each section goes full width on smaller screens
                className={classes["RataCol"]}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "900",
                }}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Total Absenteeism
                </span>

                <div className={classes["Rata1"]} style={{ padding: "2px" }}>
                  {props.data.TotalAbsentiesValue !== null
                    ? props.data.TotalAbsentiesValue.total_leaves
                    : null}
                </div>
              </Col>
            </Row>
            {/* <Col
              md={24}
              xs={24}
              className={classes["RataCol"]}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "900",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "17px", fontWeight: 600 }}
              >
                Current Pending Indent
              </span>
              <div className={classes["Rata1"]} style={{ padding: "2px" }}>
                {props.data.TotalPendingIndentValue !== null
                  ? props.data.TotalPendingIndentValue
                  : null}
              </div>
            </Col> */}
          </Row>
        </Card>
      </Col>

      <Col lg={8} md={11} xs={24} className={classes["Col"]}>
        <Card
          style={{
            background: "#daebf336",
          }}
          bordered={false}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/payroll/transactions/salary-processing"
                
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Payroll
                </span>
              </Link>
            </Col>
          </Row>
          <Row>
            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Total Payroll Cost Monthly
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.TotalMonthlySalaryValue !== null
                    ?  Math.floor(props.data.TotalMonthlySalaryValue.total_salary)
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Total Payroll Cost Yearly
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div className={classes["Rata1"]}>
                  {props.data.TotalYearlySalaryValue !== null
                    ? Math.floor(props.data.TotalYearlySalaryValue.total_salary)
                    : null}{" "}
                    

                  {/* Data */}
                </div>
              </Col>
            </Row>

    

          
          </Row>
        </Card>
      </Col>

      <Col
        lg={{ span: 8, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            backgroundColor: "#daebf336", // Very light gray with 0.9 opacity
          }}
          bordered={false}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
              to="/payroll/norms/salary-norms-create?allowance"
              
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Allowance
                </span>
              </Link>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Allowance wise Monthly
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.MonthlyAllowanceValue !== null
                    ? props.data.MonthlyAllowanceValue.allow_value_monthly
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                 Allowance wise yearly
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.YearlyAllowanceValue !== null
                    ? props.data.YearlyAllowanceValue.allow_value_yearly
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default DataCards;
